import React from 'react';
import PropTypes from 'prop-types';

import { Panel } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faFileDownload } from '@fortawesome/pro-solid-svg-icons';

import PanelHeader from 'components/importer/panel_header';

export default function ImportRequestDetails({ downloadRequestFilesPath, importRequest }) {
  const renderInfoRow = (label, value, icon) => (
    <div className="top-buffer-sm" name="details-info-row">
      <h5>{label}</h5>
      <span>
        {icon && <FontAwesomeIcon className="right-buffer-sm" icon={icon} />}
        {value}
      </span>
    </div>
  );

  const renderDownloadLinkRow = (label, value, icon, href) => (
    <div className="top-buffer-sm" name="details-link-row">
      <h5>{label}</h5>
      <a className="clickable" download href={href}>
        {icon && <FontAwesomeIcon className="right-buffer-sm" icon={icon} />}
        {value}
      </a>
    </div>
  );

  return (
    <React.Fragment>
      <PanelHeader>
        <h3>Import Request Data</h3>
      </PanelHeader>
      <Panel className="p-3">
        <Panel.Body>
          {renderInfoRow('Client', importRequest.requestedBy)}
          {renderInfoRow('Database', importRequest.databaseName, faDatabase)}
          {renderInfoRow('Import Source', importRequest.source)}
          {renderDownloadLinkRow('Files', 'Download Files', faFileDownload, downloadRequestFilesPath)}
          {renderInfoRow('Memo', importRequest.clientNotes)}
        </Panel.Body>
      </Panel>
    </React.Fragment>
  );
}

ImportRequestDetails.propTypes = {
  downloadRequestFilesPath: PropTypes.string.isRequired,
  importRequest: PropTypes.shape({
    clientNotes: PropTypes.string,
    databaseName: PropTypes.string,
    requestedBy: PropTypes.string,
    source: PropTypes.string
  }).isRequired
};
